import dayjs from 'dayjs';

export type ParticipationStatus =
  | 'ELIGIBLE'
  | 'NO_QUALIFYING_DONATION'
  | 'ALREADY_PARTICIPATED'
  | 'EVENT_NOT_STARTED'
  | 'EVENT_ENDED'
  | 'SOLD_OUT';

export type RouletteCta =
  | { kind: 'donationHistory' }
  | { kind: 'donate' }
  | { kind: 'spin' }
  | { kind: 'disabled'; label: string };

interface ResolveRouletteCtaParams {
  hasSettledResult: boolean;
  participationStatus?: ParticipationStatus;
  isSoldOut: boolean;
  startAt?: string;
}

const SOLD_OUT_LABEL = '경품이 모두 소진됐어요';

//* 결과 보유를 최우선에 둔다 — 기간 종료·소진 뒤에도 본인 당첨 화면이 유지돼야 한다(WEL-5381 BE 문서 §2).
export const resolveRouletteCta = ({
  hasSettledResult,
  participationStatus,
  isSoldOut,
  startAt,
}: ResolveRouletteCtaParams): RouletteCta => {
  if (hasSettledResult) {
    return { kind: 'donationHistory' };
  }

  if (participationStatus === 'EVENT_NOT_STARTED') {
    const startAtLabel = startAt ? dayjs(startAt).format('MM월 DD일') : '';

    return { kind: 'disabled', label: `${startAtLabel} 시작 예정`.trim() };
  }

  if (participationStatus === 'EVENT_ENDED') {
    return { kind: 'disabled', label: '이벤트가 종료됐어요' };
  }

  if (isSoldOut) {
    return { kind: 'disabled', label: SOLD_OUT_LABEL };
  }

  if (participationStatus === 'NO_QUALIFYING_DONATION') {
    return { kind: 'donate' };
  }

  return { kind: 'spin' };
};
